import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@material-ui/core";
import { IFilaEsperaPagedResponse } from "models/response/fila-espera-paged-response";
import { PaginationResponse } from "models/pagination-response";

type FilasEsperaTableProps = {
    currentItems: PaginationResponse<IFilaEsperaPagedResponse>;
};

export const FilasEsperaTable: React.FC<FilasEsperaTableProps> = ({ currentItems }) => {
    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum registro de fila de espera encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Tipo de Fila</TableCell>
                        <TableCell>Unidade</TableCell>
                        <TableCell align="right">Vagas Totais</TableCell>
                        <TableCell align="right">Matriculados</TableCell>
                        <TableCell align="right">Quantidade Aguardando</TableCell>
                        <TableCell>Última Atualização</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>{item.tipoFilaEsperaName}</TableCell>
                            <TableCell>{item.nomeUnidade || 'Não especificado'}</TableCell>
                            <TableCell align="right">{item.quantidadeVagasTotais ?? '-'}</TableCell>
                            <TableCell align="right">{item.quantidadeMatriculados ?? '-'}</TableCell>
                            <TableCell align="right">{item.quantidadeAguardando}</TableCell>
                            <TableCell>{new Date(item.dtaAtualizacao).toLocaleDateString('pt-BR')}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
